<!-- eslint-disable -->
<template>
  <div class="card bg-white border-0 rounded-3 mb-4 shadow-sm">
    <div class="card-body p-0">
      <!--      {{ authStore }}-->
      <!--      <div class="filter-container" v-if="['grand_admin', 'admin', 'manager'].includes(userRole)">-->
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 p-4">
        <div class="col-md-3">
          <input
              v-model="query.keyword"
              type="text"
              class="form-control"
              placeholder="Имя"
              @input="handleFilter"
              @keyup.enter="handleFilter"
          />
        </div>

        <div class="col-md-3">
          <select
              v-model="query.role"
              class="form-control"
              @change="handleFilter"
          >
            <option value="" selected>Выберите роль</option>
            <option v-for="item in roles" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>

        <div class="col-md-3">
          <select
              v-model="query.status"
              class="form-control"
              @change="handleFilter"
          >
            <option value="" selected>Статус работы</option>
            <option v-for="(item, index) in statuses" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>

      </div>

      <div class="default-table-area style-two all-projects">
        <div class="table-responsive">
          <table class="table table-bordered table-striped- table-hover align-middle">
            <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Имя</th>
              <th>Роль</th>
              <th>Часы / дни</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in list" :key="index">
              <td>{{ index + 1 }}</td>
              <td>
                <a v-if="row.roles.includes('recruiter_zl')" href="#" @click="openHoursModal(row.id, row.calendar)">
                  {{ row.name }}
                </a>
                <span v-else>{{ row.name }}</span>
              </td>
              <td>{{ row.roles[0] }}</td>
              <td v-if="row.roles.includes('recruiter_zl')">
                {{ row.totalWorkedHoursCurrentMonth }} / {{ row.totalWorkedDaysCurrentMonth }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>

  <div class="modal" tabindex="-1" role="dialog" :class="{ 'd-block': dialogHoursVisible }">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <!-- Modal Header with Close Icon -->
        <div class="modal-header">
          <h5 class="modal-title">Часы работы</h5>
          <button type="button" class="btn-close" @click="dialogHoursVisible = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- Admin/Manager View -->
          <div v-if="userRole === 'grand_admin' || userRole === 'admin' || userRole === 'manager'">
            <div class="calendar">
              <!-- Days of the Week Header -->
              <div class="header d-flex">
                <div class="day flex-fill text-center" v-for="day in daysOfWeek" :key="day">{{ day }}</div>
              </div>

              <!-- Month Controls -->
              <div class="month-controls d-flex justify-content-between align-items-center my-3">
                <button class="btn btn-outline-secondary" @click="prevMonth">Назад</button>
                <span class="font-weight-bold">{{ monthNames[currentMonth] }} {{ currentYear }}</span>
                <button class="btn btn-outline-secondary" @click="nextMonth">Вперед</button>
              </div>

              <!-- Calendar Grid -->
              <div class="grid">
                <div
                    class="cell p-2 border text-center"
                    v-for="(cell, index) in calendarCells"
                    :key="index"
                    :class="{ 'bg-light-': !cell.date }"
                >
                  <div v-if="cell.date" class="date font-weight-bold mb-2">{{ cell.date }}</div>
                  <input
                      v-if="cell.date"
                      type="time"
                      v-model="cell.startTime"
                      @change="calculateTotalWorkingHours"
                      class="form-control form-control-sm mb-1"
                      placeholder="Start Time"
                  />
                  <input
                      v-if="cell.date"
                      type="time"
                      v-model="cell.endTime"
                      @change="calculateTotalWorkingHours"
                      class="form-control form-control-sm"
                      placeholder="End Time"
                  />
                </div>
              </div>

              <!-- Footer -->
              <div class="footer d-flex justify-content-between align-items-center mt-3">
                <div class="footer-text">
                  Всего часов в текущем месяце: <strong>{{ totalHoursUser }}</strong>
                </div>
                <div class="footer-button">
                  <button class="btn btn-primary" @click="saveCalendarNew">
                    Сохранить часы (текущий месяц)
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Recruiter View -->
          <div v-if="userRole === 'recruiter_zl'">
            <small> Всего часов текущий месяц: {{ totalHoursWorked }} </small>

            <table class="table table-bordered mt-3">
              <thead>
              <tr>
                <th>Дата</th>
                <th>Начало работы</th>
                <th>Конец работы</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row, index) in filteredDaysOfMonth" :key="index">
                <td>{{ row.date }}</td>
                <td>
                  <input
                      type="time"
                      v-model="row.startTime"
                      class="form-control form-control-sm"
                      :disabled="
                        (authUserData.userRole !== 'grand_admin' && authUserData.userRole !== 'manager') ||
                        row.startTime !== ''
                      "
                  />
                </td>
                <td>
                  <input
                      type="time"
                      v-model="row.endTime"
                      class="form-control form-control-sm"
                      :disabled="
                        (authUserData.userRole !== 'grand_admin' && authUserData.userRole !== 'manager') ||
                        row.endTime !== ''
                      "
                  />
                </td>
              </tr>
              </tbody>
            </table>
            <button class="btn btn-primary" @click="submitCalendarData">
              Отправить данные
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import UserResource from '@/api/user';
import {useAuthStore} from "@/stores/auth";
import {saveCalendar} from '@/api/actualization';

const userResource = new UserResource();

export default {
  name: 'Ratings',
  data() {
    return {
      authStore: useAuthStore(),
      authUserData: [],
      userData: [],
      activeActivity: 'first',
      updating: false,
      currentDate: new Date(),
      downloadLoading: false,
      userCalendar: [],
      userCalendarForUser: 0,
      totalHoursUser: 0,
      totalHoursWorked: 0,
      daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
      calendarCells: [],
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      workedHours: [],
      list: null,
      total: 0,
      totalHours: [],
      daysOfMonth: [],
      loading: true,
      downloading: false,
      userCreating: false,
      query: {
        page: 1,
        limit: 150,
        keyword: '',
        role: null,
        status: 'Работает',
      },
      statuses: ['Работает', 'Не работает',],
      roles: ['Гранд Админ', 'Админ', 'Наблюдатель', 'Координатор', 'Рекрутер Ś/U', 'Рекрутер ZL', 'Менеджер', 'Главный координатор'],
      rolesForAdmin: ['Админ', 'Наблюдатель', 'Координатор', 'Рекрутер Ś/U', 'Рекрутер ZL', 'Менеджер', 'Главный координатор'],
      rolesForManager: ['Координатор', 'Рекрутер Ś/U', 'Рекрутер ZL', 'Главный координатор'],
      rolesForCoordinatorMain: ['Координатор'],
      newUser: {},
      dialogHoursVisible: false,
      dialogFormVisible: false,
      dialogPermissionVisible: false,
      dialogPermissionLoading: false,
      currentUserId: 0,
      currentUser: {
        name: '',
        permissions: [],
        rolePermissions: [],
      },
      rules: {
        role: [{required: true, message: 'Роль обязательна', trigger: 'change'}],
        name: [{required: true, message: 'Имя обязательно', trigger: 'blur'}],
        username: [{required: true, message: 'Логин обязателен', trigger: 'blur'}],
        password: [{required: true, message: 'Пароль обязателен', trigger: 'blur'}],
      },
      permissionProps: {
        children: 'children',
        label: 'name',
        disabled: false,
      },
      permissions: [],
      menuPermissions: [],
      otherPermissions: [],
      randomPassword: '',
    };
  },
  created() {
    this.parseRoleFromUrl();
    this.getList();
  },
  methods: {
    submitCalendarData() {
      const dataToSend = {
        days: this.daysOfMonth,
        user_id: this.userData.id,
      }
      saveCalendar(dataToSend).then(() => {
        this.$notify({
          title: 'Успешно',
          message: 'Успешно',
          type: 'success',
          duration: 2000,
        });
        window.location.reload();
      });
    },
    // filteredDaysOfMonth() {
    //   //const currentDateStr = this.formatDate(this.currentDate);
    //   const currentDateStr = this.currentDate;
    //   return this.daysOfMonth.filter(day => day.date === currentDateStr);
    // },
    generateCalendar() {
      console.log(this.userCalendar);
      console.log(this.userCalendarForUser);

      const firstDayOfMonth = new Date(this.currentYear, this.currentMonth, 1);
      const lastDayOfMonth = new Date(this.currentYear, this.currentMonth + 1, 0);

      // Calculate the starting position of the calendar (offset by the first day of the month)
      const startOffset = firstDayOfMonth.getDay();

      // Create empty cells for the days before the start of the month
      this.calendarCells = [];
      for (let i = 0; i < startOffset; i++) {
        this.calendarCells.push({}); // Empty cell
      }

      // Create cells for each day of the month
      for (let day = 1; day <= lastDayOfMonth.getDate(); day++) {
        // Initialize the cell with default values
        let cell = {
          userId: this.userCalendarForUser,
          date: day,
          month: this.currentMonth + 1,
          year: this.currentYear,
          startTime: '',
          endTime: ''
        };

        // Check if there are any events for this day
        const dateStr = `${this.currentYear}-${String(this.currentMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        const event = this.userCalendar.find(event => event.date === dateStr);

        // If an event is found, update the startTime and endTime
        if (event) {
          cell.startTime = event.start_time;
          cell.endTime = event.end_time;
        }

        // Add the cell to the calendar
        this.calendarCells.push(cell);
      }

      for (let day = 1; day <= lastDayOfMonth.getDate() + 1; day++) {
        this.calculateTotalWorkingHours();
      }
    },
    prevMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear--;
      } else {
        this.currentMonth--;
      }
      this.generateCalendar();
    },
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear++;
      } else {
        this.currentMonth++;
      }
      this.generateCalendar();
    },
    calculateTotalWorkingHours() {
      // Initialize the total working hours variable
      let totalWorkingHours = 0;

      console.log('Starting calculation of total working hours.');
      console.log('Calendar cells:', this.calendarCells);
      console.log('Number of calendar cells:', this.calendarCells.length);

      // Calculate the working hours for each cell
      for (const cell of this.calendarCells) {
        if (cell.startTime && cell.endTime) {
          try {
            const start = new Date(`${cell.year}-${String(cell.month).padStart(2, '0')}-${String(cell.date).padStart(2, '0')}T${cell.startTime}`);
            const end = new Date(`${cell.year}-${String(cell.month).padStart(2, '0')}-${String(cell.date).padStart(2, '0')}T${cell.endTime}`);

            // Check if the end time is after the start time
            if (end > start) {
              const hoursWorked = (end - start) / (1000 * 60 * 60); // Difference in hours

              // Log the details for each day
              console.log(`Date: ${cell.date}-${cell.month}-${cell.year}`);
              console.log(`Start Time: ${cell.startTime}`);
              console.log(`End Time: ${cell.endTime}`);
              console.log(`Hours Worked: ${hoursWorked.toFixed(2)}`);
              console.log('---');

              // Add to the total working hours
              totalWorkingHours += hoursWorked;
            } else {
              //console.warn(`Invalid time range for ${cell.date}-${cell.month}-${cell.year}: startTime (${cell.startTime}) is after endTime (${cell.endTime})`);
            }
          } catch (error) {
            //console.error(`Error parsing dates for ${cell.date}-${cell.month}-${cell.year}:`, error);
          }
        } else {
          //console.debug(`Missing startTime or endTime for ${cell.date}-${cell.month}-${cell.year}`);
        }
      }

      this.totalHoursUser = Math.floor(totalWorkingHours);
      console.log('Total working hours calculated:', totalWorkingHours);
    },
    generateDaysOfMonth() {
      const daysInMonth = new Date(this.currentYear, this.currentMonth + 1, 0).getDate();
      const calendarMap = this.userData && this.userData.calendar ? this.userData.calendar.reduce((map, entry) => {
        map[entry.date] = entry;
        return map;
      }, {}) : {};

      this.daysOfMonth = []; // Ensure to reset the array before pushing new data
      this.totalHoursWorked = 0; // Reset total hours worked

      for (let day = 1; day <= daysInMonth; day++) {
        const dateStr = `${this.currentYear}-${String(this.currentMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        const calendarEntry = calendarMap[dateStr];

        const startTime = calendarEntry ? calendarEntry.start_time ? calendarEntry.start_time.slice(0, 5) : '' : '';
        const endTime = calendarEntry ? calendarEntry.end_time ? calendarEntry.end_time.slice(0, 5) : '' : '';

        if (startTime && endTime) {
          const start = new Date(`${dateStr}T${startTime}:00`);
          const end = new Date(`${dateStr}T${endTime}:00`);
          let hoursWorked = (end - start) / (1000 * 60 * 60); // Convert milliseconds to hours
          hoursWorked = Math.floor(hoursWorked); // Floor to the nearest lower whole number
          this.totalHoursWorked += hoursWorked;
        }

        this.daysOfMonth.push({
          date: dateStr,
          startTime,
          endTime
        });
      }
    },
    async getList() {
      const {limit, page} = this.query;
      this.loading = true;
      const {data, meta} = await userResource.list(this.query);
      this.list = data;
      this.list.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;

      try {
        const data1 = await this.$store.dispatch('user/getInfo');
        this.authUserData = data1;
        const id = this.$route.params && this.$route.params.id;
        const currentUserId = this.$store.getters.userId;
        if (id !== undefined) {
          if (id === currentUserId) {
            this.userData = data1;
            this.generateDaysOfMonth();
          } else {
            const {data: data2} = await userResource.get(id);
            this.userData = data2;
            if (this.userData) {
              this.generateDaysOfMonth();
            }
          }
        } else {
          this.userData = data1;
          this.generateDaysOfMonth();
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },
    async getListUpdate() {
      const {data, meta} = await userResource.list(this.query);
      this.list = data;
    },

    /*    calculateTotalHoursForMonth(calendar, userId) {
          const now = new Date();
          const year = now.getFullYear();
          const month = now.getMonth();
          const firstDayOfMonth = new Date(year, month, 1);
          const lastDayOfMonth = new Date(year, month + 1, 0);
          let totalHours = 0;

          // Filter calendar entries for the specified user within the current month
          const entries = calendar.filter(entry => {
            const entryDate = new Date(entry.date);
            return entry.user_id === userId &&
              entryDate >= firstDayOfMonth &&
              entryDate <= lastDayOfMonth &&
              entry.start_time && entry.end_time;
          });


          entries.forEach(entry => {
            const {start_time, end_time} = entry;
            if (start_time && end_time) {
              try {
                // Ensure times are in 'HH:mm' format and parse them correctly
                const [startHour, startMinute] = start_time.split(':').map(Number);
                const [endHour, endMinute] = end_time.split(':').map(Number);

                // Ensure that both start and end time are valid
                if (isNaN(startHour) || isNaN(startMinute) || isNaN(endHour) || isNaN(endMinute)) {
                  console.error(`Invalid time format for entry: ${entry}`);
                  return;
                }

                const startDateTime = new Date(`${entry.date}T${start_time}`);
                const endDateTime = new Date(`${entry.date}T${end_time}`);

                // Ensure that startDateTime is before endDateTime
                if (startDateTime >= endDateTime) {
                  console.error(`Start time is not before end time for entry: ${entry}`);
                  return;
                }

                const diffMillis = endDateTime - startDateTime;
                const diffHours = diffMillis / (1000 * 60 * 60);
                totalHours += diffHours;
              } catch (error) {
                console.error(`Error calculating hours for entry: ${entry}`, error);
              }
            }
          });

          // Return total hours rounded to two decimal places
          return Math.round(totalHours * 100) / 100;
        },*/

    onDateChange(calendar, date, id) {
      this.$nextTick(() => {
        const existingEntry = this.findCalendarEntry(calendar, date, id);
        if (existingEntry) {
          this.$set(calendar, 'start_time', existingEntry.start_time);
          this.$set(calendar, 'end_time', existingEntry.end_time);
        } else {
          this.$set(calendar, 'start_time', null);
          this.$set(calendar, 'end_time', null);
        }
      });

      //console.log(`Total hours worked in the month: ${totalHours} hours`);
      //this.totalHours[id] = this.calculateTotalHoursForMonth(calendar, id);

    },

    getWorkedHours(userId, date) {
      if (date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const formattedMonth = `${year}-${month}`;
        return this.workedHours[userId] && this.workedHours[userId][formattedMonth] || 0;
      } else {
        return null;
      }
    },

    formatDate(date) {
      const adjustedDate = new Date(date);
      adjustedDate.setUTCDate(adjustedDate.getUTCDate() + 1);
      return adjustedDate.toISOString().slice(0, 10);
    },

    formatDate2(date) {
      const adjustedDate = new Date(date);
      adjustedDate.setUTCDate(adjustedDate.getUTCDate());
      return adjustedDate.toISOString().slice(0, 10);
    },

    findCalendarEntry(calendar, date, id) {
      const formattedDate = this.formatDate(date);
      return calendar.find(entry => entry.date === formattedDate && entry.user_id === id);
    },

    calculateTotalWorkedHours(calendar, formattedDate) {
      // Extract year and month from formattedDate
      const [year, month] = formattedDate.split('-');

      let totalHours = 0;

      // Iterate over each entry in the calendar
      calendar.forEach(entry => {
        // Split the date of the entry to get year and month
        const [entryYear, entryMonth] = entry.date.split('-');

        // Check if the entry is within the same year and month
        if (entryYear === year && entryMonth === month && entry.start_time && entry.end_time) {
          // Parse the start and end times
          const startTime = new Date(`1970-01-01T${entry.start_time}Z`);
          const endTime = new Date(`1970-01-01T${entry.end_time}Z`);

          // Calculate the difference in hours
          const diffInHours = (endTime - startTime) / (1000 * 60 * 60);

          // Add to the total hours
          totalHours += diffInHours;
        }
      });

      // Round the final total hours to the nearest whole number
      return Math.round(totalHours);
    },
    saveWorkHoursOnDateChange(userId, calendar) {
      const selectedDate = calendar.date;
      const selectedStart = calendar.start_time;
      const selectedEnd = calendar.end_time;

      const year = selectedDate.getFullYear();
      const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
      const day = String(selectedDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      const formattedMonth = `${year}-${month}`;

      const totalWorkedHours = this.calculateTotalWorkedHours(calendar, formattedDate);
      console.log("Total Worked Hours:", totalWorkedHours);

      if (!this.workedHours[userId]) {
        this.$set(this.workedHours, userId, {});
      }
      this.$set(this.workedHours[userId], formattedMonth, totalWorkedHours);
    },
    saveCalendarNew() {
      saveCalendar(this.calendarCells).then(() => {
        //window.location.href = '/#/stats/hours?save=' + Math.random();
        window.location.reload();
      });
    },

    saveWorkHours(userId, calendar) {
      const selectedDate = calendar.date;
      const selectedStart = calendar.start_time;
      const selectedEnd = calendar.end_time;

      const year = selectedDate.getFullYear();
      const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
      const day = String(selectedDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      const formattedMonth = `${year}-${month}`;

      // Collect data and send to backend
      const dataToSend = {
        user_id: userId,
        date: selectedDate || '',
        start_time: selectedStart || '',
        end_time: selectedEnd || ''
      };

      const calendarEntry = calendar.find(entry => entry.date === formattedDate);

      // If a matching date is found, update the start_time and end_time
      if (calendarEntry) {
        calendarEntry.start_time = selectedStart;
        calendarEntry.end_time = selectedEnd
      } else {
        const newEntry = {
          date: formattedDate,
          start_time: selectedStart,
          end_time: selectedEnd,
          user_id: userId
        };
        calendar.push(newEntry);
      }

      console.log(calendar);
      const totalWorkedHours = this.calculateTotalWorkedHours(calendar, formattedDate);
      console.log("Total Worked Hours:", totalWorkedHours);


      if (!this.workedHours[userId]) {
        this.$set(this.workedHours, userId, {});
      }
      this.$set(this.workedHours[userId], formattedMonth, totalWorkedHours);

      saveCalendar(dataToSend).then(() => {
        //this.getListUpdate();
        // this.$notify({
        //   title: 'Успешно',
        //   message: 'Успешно',
        //   type: 'success',
        //   duration: 2000,
        // });
        //window.location.reload();
      });
    },
    openHoursModal(user_id, calendar) {
      this.userCalendar = calendar;
      this.userCalendarForUser = user_id;
      this.generateCalendar();
      this.dialogHoursVisible = true;
    },
    parseRoleFromUrl() {
      let roleInt;
      const path = this.$route.path;
      const regex = /role(\d+)/;
      const match = path.match(regex);
      if (match && match[1]) {
        roleInt = parseInt(match[1]);
      } else {
        roleInt = parseInt(this.$route.query.role) || null;
      }
      if (roleInt === 1) {
        this.query.role = 'Гранд Админ';
      } else if (roleInt === 2) {
        this.query.role = 'Наблюдатель';
      } else if (roleInt === 3) {
        this.query.role = 'Админ';
      } else if (roleInt === 4) {
        this.query.role = 'Админ';
      } else if (roleInt === 5) {
        this.query.role = 'Рекрутер Ś/U';
      } else if (roleInt === 6) {
        this.query.role = 'Рекрутер ZL';
      }

      if (this.query.role) {
        this.getList()
      }
    },
    handleFilter() {
      const searchQuery = this.query.keyword?.trim(); // Ensure search is trimmed and exists

      if (!searchQuery) {  // If searchQuery is null, undefined, or empty, reset the filter
        this.query.keyword = '';
        this.query.page = 1;
        this.getList();  // Return full list
      } else if (searchQuery.length === 1) {
        // Do nothing if length is 1
        return;
      } else if (searchQuery.length > 1) {  // If length > 1, search and save
        this.query.page = 1;
        this.getList();
      }
    },
    handleCreate() {
      this.resetNewUser();
      this.dialogFormVisible = true;
      this.randomPassword = this.generateRandomPassword(8)
      this.newUser.password = this.randomPassword
      this.newUser.confirmPassword = this.randomPassword
      this.$nextTick(() => {
        this.$refs['userForm'].clearValidate();
      });
    },
    generateRandomPassword(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+`|:?>';
      let result = '';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    handleDelete(id, name) {
      this.$confirm('Удалить навсегда ' + name + '. Продолжить?', 'Предупреждение', {
        confirmButtonText: 'Подтвердить',
        cancelButtonText: 'Отменить',
        type: 'warning',
      }).then(() => {
        userResource.destroy(id).then(response => {
          this.$message({
            type: 'success',
            message: 'Delete completed',
          });
          this.handleFilter();
        }).catch(error => {
          console.log(error);
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled',
        });
      });
    },
    async handleEditPermissions(id) {
      this.currentUserId = id;
      this.dialogPermissionLoading = true;
      this.dialogPermissionVisible = true;
      const found = this.list.find(user => user.id === id);
      const {data} = await userResource.permissions(id);
      this.currentUser = {
        id: found.id,
        name: found.name,
        permissions: data,
      };
      this.dialogPermissionLoading = false;
      this.$nextTick(() => {
        this.$refs.menuPermissions.setCheckedKeys(this.permissionKeys(this.userMenuPermissions));
        this.$refs.otherPermissions.setCheckedKeys(this.permissionKeys(this.userOtherPermissions));
      });
    },
    createUser() {
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          this.newUser.roles = [this.newUser.role];
          this.userCreating = true;
          userResource
              .store(this.newUser)
              .then(response => {
                this.$message({
                  message: 'Новый пользователь ' + this.newUser.name + '(' + this.newUser.username + ') успешно создан.',
                  type: 'success',
                  duration: 5 * 1000,
                });
                this.resetNewUser();
                this.dialogFormVisible = false;
                this.handleFilter();
              })
              .catch(error => {
                console.log(error);
              })
              .finally(() => {
                this.userCreating = false;
              });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetNewUser() {
      this.newUser = {
        name: '',
        username: '',
        password: '',
        confirmPassword: '',
        role: '',
      };
    },
    handleDownload() {
      // this.downloading = true;
      // import('@/vendor/Export2Excel').then(excel => {
      //   const tHeader = ['Имя', 'Логин'];
      //   const filterVal = ['name', 'username'];
      //   const data = this.formatJson(filterVal, this.list);
      //   excel.export_json_to_excel({
      //     header: tHeader,
      //     data,
      //     filename: 'user-list',
      //   });
      //   this.downloading = false;
      // });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
  },
  computed: {
    filteredDaysOfMonth() {
      if (this.authUserData.userRole === 'grand_admin' || this.authUserData.userRole === 'admin' || this.authUserData.userRole === 'manager') {
        return this.daysOfMonth;
      } else {
        const currentDateStr = this.formatDate2(this.currentDate);
        return this.daysOfMonth.filter(day => day.date === currentDateStr);
      }
    },
    userRole() {
      return 'grand_admin';
    },
  },
};
</script>

<!-- eslint-enable -->
<style scoped>
.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

.calendar {
  border: 1px solid #ddd;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-width: 900px;
  padding: 10px;
  box-sizing: border-box;
}

.header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  background-color: #f0f0f0;
  font-weight: bold;
}

.day {
  padding: 10px;
  text-align: center;
}

.month-controls {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: minmax(100px, auto);
  gap: 1px;
}

.cell {
  border: 1px solid #ddd;
  background-color: #fff;
  text-align: center;
  padding: 5px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.cell.empty {
  background-color: #f9f9f9;
}

.date {
  font-size: 1.2em;
  margin-bottom: 5px;
}

.time-inputs {
  display: flex;
  justify-content: space-between;
  gap: 2px;
}

input[type="time"] {
  padding: 2px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.footer {
  margin-top: 10px;
  text-align: center;
}

.footer-text {
  margin-bottom: 10px;
}

.footer-button {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.footer-button button {
  padding: 5px 15px;
  font-size: 16px;
  cursor: pointer;
}

@media (max-width: 600px) {
  .calendar {
    width: 100%;
  }
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #000;
  opacity: 0.5;
  transition: opacity 0.2s ease;
}

.btn-close:hover {
  opacity: 1;
}
</style>